// Dynamic category-specific parameter blueprints (shared by SellMachine + ListingDetail).
// Multilingual option datasets — value is the canonical id stored in the DB.

export const HUMAN_INTENTS = [
  { value: "oferta_mentor", ro: "Sunt Mentor / Ofer Formare", hu: "Mentor vagyok / Képzést kínálok", en: "I am a Mentor / Offering Training" },
  { value: "caut_ucenic", ro: "Caut Ucenic (Mester / Fabrică)", hu: "Inast keresek (Mester / Üzem)", en: "Seeking Apprentice (Master / Mill)" },
  { value: "caut_loc_munca_ucenic", ro: "Doresc să Învăț / Caut Ucenicie", hu: "Tanulni szeretnék / Inashelyet keresek", en: "Want to Learn / Seeking Apprenticeship" },
  { value: "muncitor_calificat", ro: "Muncitor Calificat (Caut Loc de Muncă)", hu: "Szakmunkás (Állást keresek)", en: "Qualified Worker (Seeking Job)" },
  { value: "ajutor_muncitor", ro: "Ajutor de Muncitor / Seged (Caut Loc de Muncă)", hu: "Segédmunkás (Állást keresek)", en: "Helper / General Labor (Seeking Job)" },
  { value: "donatie_utilaj", ro: "Donație Utilaj / Scule", hu: "Gép- vagy szerszámfelajánlás (Adomány)", en: "Machinery / Tool Donation" },
];

export const ENGAGEMENT_TYPES = [
  { value: "voluntariat_social", ro: "Voluntariat / Mentorat Social", hu: "Önkéntesség / Társadalmi mentorálás", en: "Volunteer / Social Mentorship" },
  { value: "platit_angajare", ro: "Plătit (Angajare / Contract de Muncă)", hu: "Fizetett munka (Alkalmazás / Munkaszerződés)", en: "Paid (Employment / Labor Contract)" },
  { value: "serviciu_orificiu", ro: "Serviciu Comercial / Tarif pe Oră", hu: "Kereskedelmi szolgáltatás / Óradíj", en: "Commercial Service / Hourly Rate" },
  { value: "parteneriat_investitii", ro: "Parteneriat / Investiție (OXO Capital)", hu: "Partnerség / Befektetés (OXO Capital)", en: "Partnership / Investment (OXO Capital)" },
];

export const MACHINE_CONDITIONS = [
  { value: "nou", ro: "Nou", hu: "Új", en: "New" },
  { value: "recond", ro: "Recondiționat", hu: "Felújított", en: "Reconditioned" },
  { value: "functional", ro: "Funcțional / Bună", hu: "Működő / Jó", en: "Functional / Good" },
  { value: "piese", ro: "Pentru piese / Reparații", hu: "Alkatrésznek / Javításra", en: "For parts / Repairs" },
];

const lng2 = (l) => (l || "ro").slice(0, 2);
export const optLabel = (o, lng = "ro") => (o ? (o[lng2(lng)] || o.ro) : "");
export const findOptLabel = (arr, value, lng = "ro") => {
  const o = arr.find((x) => x.value === value);
  return o ? optLabel(o, lng) : value;
};

// Resolve a stored dynamic_specs value to a display string (localized for selects).
export const dynDisplayValue = (key, val, lng = "ro") => {
  if (key === "human_intent") return findOptLabel(HUMAN_INTENTS, val, lng);
  if (key === "engagement_type") return findOptLabel(ENGAGEMENT_TYPES, val, lng);
  if (key === "machine_condition") return findOptLabel(MACHINE_CONDITIONS, val, lng);
  if (key === "is_vetted") return val ? "✓" : "—";
  return String(val);
};

// Which primary groups carry a specialized numeric/technical blueprint (hides generic spec grid).
export const BLUEPRINT_PRIMARIES = ["utilaje-secundare", "uscare-termice"];
